import { ASYNC_SUCCESS } from '../actions'

const companies = (state = null, { type, payload }) => {
  switch (type) {
    case ASYNC_SUCCESS:
      switch (payload.actionName) {
        case 'addCompany': {
          // without empty object users - crashing when assigning something into it
          return { ...state, ...payload.company, users: {} }
        }

        case 'fetchCompanies': {
          return {
            ...state,
            ...payload.companies
          }
        }

        case 'addUser': {
          const newState = { ...state }

          payload.postData.companies.forEach(company => {
            newState[company.companyId].users[payload.userId] = {
              name_sync: payload.postData.name,
              role: company.role
            }
          })

          return {
            ...newState
          }
        }

        case 'editCompanyGeneral': {
          const { companyId, fields } = payload

          return {
            ...state,
            [companyId]: {
              ...state[companyId],
              ...fields
            }
          }
        }

        case 'editCompanyUsers': {
          const { companyId, users } = payload

          return {
            ...state,
            [companyId]: {
              ...state[companyId],
              users
            }
          }
        }

        default:
          return state
      }

    default:
      return state
  }
}

export default companies



// WEBPACK FOOTER //
// ./src/reducers/companies.js